<template>
	<v-container class="resources-adv__list pa-0 pt-5">
		<div
			v-bind:style="{
                display: 'grid',
                gridTemplateColumns: `repeat(${getColsByDisplayWidth}, 1fr)`,
                gap: '8px'
            }"
		>
			<v-col
				v-for="resourceItem in resourcesItems"
				:key="resourceItem.resource_id"
				class="resources-adv__list-item"
			>
				<router-link
					:to="resourceLink(resourceItem)"
					@click.native="handleResourceClick(resourceItem)"
				>
					<div
						v-if="resourceItem.resource_type === 3"
						class="resources-adv__list-item-img pl-4"
					>
						<Icon
							:type='resourceItem.ico'
							:color='resourceItem.color'
							:size='40'
							:pr="16"
						/>
					</div>
					<div
						v-else
						class="resources-adv__list-item-img pl-6"
						:style="{ backgroundImage: backgroundImage(resourceItem) }"
					>
						<div v-if="backgroundImage(resourceItem) === 'none'">
							<ResourceFileIcon  :fileName="resourceItem.upload.file_real_name" :url="resourceItem.upload.url" :mr="16" />
						</div>
						<div v-else class="resources-adv__list-item-img-file-icon">
							<ResourceFileIcon  :fileName="resourceItem.upload.file_real_name" :url="resourceItem.upload.url" :mr="16"/>
						</div>
					</div>
					<p class="resources-adv__list-item-title ma-0 mt-2" style="text-decoration: underline;">
						{{ resourceItem.resources_name || resourceItem.upload.file_real_name }}
					</p>
				</router-link>
			</v-col>
		</div>
	</v-container>
</template>

<script>
import ResourceFileIcon from './ResourceFileIcon.vue'
import Icon from '@/components/Icon'
import Dwh from '@/mixins/Dwh'

export default {
	components: {
		Icon,
		ResourceFileIcon,
	},
	mixins: [Dwh],
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		}
	},
	methods: {
		resourceLink(resourceItem) {
			const name = resourceItem.resource_type === 3 ? 'resource' : 'resource-file'
			const params = {
				name,
				params: {
					id: resourceItem.resource_id
				}
			}
			if (resourceItem.resource_type === 3) {
				params.query = {advance: '1', title: resourceItem.resources_name}
			}
			return params
		},
		backgroundImage(resourceItem) {
			return resourceItem.resource_image ? `url(${resourceItem.resource_image})` : 'none'
		},
		fileType(resourceItem) {
			if (resourceItem.upload.metadata) {
				return resourceItem.upload.filename.substring(resourceItem.upload.filename.lastIndexOf('.') + 1)
			} else {
				return 'file'
			}
		},
		handleResourceClick(resourceItem) {
			this.sendTrigger({
				category: 'Content',
				action: resourceItem.resource_type === 3 ? 'click_resources_folder' : 'click_resources_file',
				module: 'Resources',
				data: resourceItem.resource_id,
				title: resourceItem.resources_name,
				content_chapter_id: resourceItem.chapter_id ? [resourceItem.chapter_id] : null
			})
		}
	},
	computed: {
		getColsByDisplayWidth() {
			const displayWidth = this.$vuetify.breakpoint.width
			return displayWidth >= 600 ? '3' : displayWidth <= 380 ? '1' : '2'
		}
	}
}
</script>

<style lang="scss">
.resources-adv__list {
	&-item {
		background-color: #fff;
		border-radius: 8px;
		padding: 8px;

		&-img {
			background-color: #F3F3F6;
			border-radius: 8px;
			height: 152px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			background-position: center;
			background-size: cover;
			background-repeat: no-repeat;
			position: relative;

			&-file {
				background-color: var(--accent-color);

				&-icon, &-icon-small {
					display: flex;
					justify-content: center;
					align-items: center;
					position: absolute;
					bottom: 4px;
					right: -12px;

					img {
						height: 20px;
						width: 20px;
					}

					&-small {
						width: 20px;
						height: 20px;
						border-radius: 4px;
						right: 12px;
					}
				}
				&-icon-common {
					img {
						mix-blend-mode: multiply;
					}
				}
			}
		}

		&-title {
			font-size: 12px;
			font-weight: 700;
			color: var(--ceil-detail-text-color);
			cursor: pointer;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			word-break: break-word;
			min-height: 32px;
			line-height: 16px;
		}
	}
}
</style>